/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/** Common Components */
import CardSection from "../../../../components/ui/card/CardSection";

/** Common Services & Data Files */
import ToastService from "../../../../services/toastService/ToastService";
import { getTeamPlanningMessageType, isTeamPlanningSuccessMessage } from "../../utils/teamPlanningResponse";

/** Configuration Files */

/** RTK Query */
import {
  useLazyGetAllResourcePlanningListQuery,
  useUpdateteamResourceplanningMutation,
} from "../../../../app/services/teamResourcePlanningAPI";

/** CSS Files */
import "./ResourcePlanning.scss";

/** Lazily Loaded Components */
import TeamTaskPlanning from "../plannedTasks/TeamTaskPlanning";
import DataLoader from "../../../../components/ui/dataLoader/DataLoader";

const getNumberValue = (...values) => {
  const value = values.find((item) => item !== null && item !== undefined && item !== "");
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const formatHours = (value) => getNumberValue(value).toFixed(2).replace(/\.00$/, "");

const ResourcePlanning = (props) => {

  const teamId = props.teamData.teamId;
  const planningId = props?.teamData?.planningId;
  const isReadOnly = props.isReadOnly === true;

  /* State */
  const [dataSource, setDataSource] = useState([]);

  // API Calls
  const [getAllResourcePlanningList, {
    isLoading: isPlanningListLoading,
    isSuccess: isPlanningListSuccess,
    data: isPlanningListData,
  },] = useLazyGetAllResourcePlanningListQuery();

  const [updateteamResourceplanning, {
    isLoading: isTeamResourcePlanningUpdating,
    isSuccess: isResourcePlanningUpdated,
    data: ResourcePlanningData,
  },] = useUpdateteamResourceplanningMutation();

  /** useEffect's **/
  useEffect(() => {
    if (teamId && planningId) {
      getAllResourcePlanningList({ teamId, planningId });
    }
  }, [teamId, planningId]);

  useEffect(() => {
    if (isPlanningListSuccess && isPlanningListData) {
      setDataSource(isPlanningListData);
    }
  }, [isPlanningListSuccess, isPlanningListData]);

  useEffect(() => {
    if (isResourcePlanningUpdated && ResourcePlanningData) {
      const message = ResourcePlanningData.errorMessage;
      ToastService[getTeamPlanningMessageType(message)](message);
      if (!isTeamPlanningSuccessMessage(message)) return;

      getAllResourcePlanningList({ teamId, planningId });
      if (props.onPlanningDataChanged) {
        props.onPlanningDataChanged();
      } else {
        props.getResourceTotalPlanningCount?.({
          teamId: teamId,
          planningId: planningId,
        });
      }
    }
  }, [isResourcePlanningUpdated, ResourcePlanningData]);

  // Functions
  // const handleEditClick = (newSelectedOptions, index) => {
  //   if (newSelectedOptions) {
  //     updateteamResourceplanning({
  //       workingDays: Number(newSelectedOptions.workingDays),
  //       resourcePlanningId: dataSource[index].resourcePlanningId,
  //       teamId: teamId,
  //       planningID: planningId,
  //       userId: dataSource[index].userId,
  //       productive: Number(newSelectedOptions.productive),
  //     });
  //   }
  // };

  const handleSuccess = () => {
    getAllResourcePlanningList({ teamId, planningId });
    if (props.onPlanningDataChanged) {
      props.onPlanningDataChanged();
      return;
    }
    props.getResourceTotalPlanningCount?.({
      teamId: teamId,
      planningId: planningId,
    });
  }

  // Est. Hrs must come only from tasks linked to this planning (API),
  // not from candidate/unlinked project tasks shown in the right panel.
  const getEstimatedHours = (item) => {
    if (String(item.name).toLowerCase() === "total") {
      return dataSource
        .filter((row) => String(row.name).toLowerCase() !== "total")
        .reduce((total, row) => total + getEstimatedHours(row), 0);
    }

    return getNumberValue(
      item.esitmated_Hr,
      item.estimated_Hr,
      item.estimatedHr,
      item.estimatedHours
    );
  };

  const getRemainingHours = (item) => {
    const productiveHours = getNumberValue(
      item.productive_Hr,
      item.productiveHr,
      item.productiveHours
    );
    return Math.max(productiveHours - getEstimatedHours(item), 0);
  };

  return (
    <div className="resource-plan-sec d-flex">
      <div
        className={`resource-plan-section collapsed`} 
      >
        <CardSection
          
          isContentLoading={isPlanningListLoading}
        >
          {isTeamResourcePlanningUpdating ? <DataLoader /> :
            <div className="collapsed-resource-grid">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Prod. Hrs</th>
                    <th>Est. Hrs</th>
                    <th>Rem. Hrs</th>
                  </tr>
                </thead>
                <tbody>
                  {dataSource.map((item, index) => (
                    <tr key={index + 1}>
                      <td>{item.name}</td>
                      <td>{formatHours(item.productive_Hr ?? item.productiveHr ?? item.productiveHours)}</td>
                      <td>{formatHours(getEstimatedHours(item))}</td>
                      <td>{formatHours(getRemainingHours(item))}</td>
                    </tr> 
                  ))}
                </tbody>
              </table>
            </div>
          }
        </CardSection>
      </div>
      <div className="task-plan-section expanded">
        <CardSection isContentLoading={isPlanningListLoading}>
          <TeamTaskPlanning
            onSuccess={handleSuccess}
            teamData={props.teamData}
            getResourceTotalPlanningCount={props.getResourceTotalPlanningCount}
            isReadOnly={isReadOnly}
          />
        </CardSection>
      </div>

    </div>

  );
};

export default ResourcePlanning;
